import React, { useContext, useEffect } from 'react';
import { Container } from 'src/components';
import Button from '../../components/Button';
import { SCREENS } from '../../constants';
import { GlobalContext } from '../../context/GlobalState';
import * as S from './style';
import Tabs, { Tab } from '../../components/Tabs';
import TemplatesTab from './TemplatesTab';
import { getBoolean, getRemoteConfig } from 'firebase/remote-config';
import { TrackingEvents, logEvent } from '../../tracking';

function Settings() {
  const { onChangeScreen } = useContext(GlobalContext);
  const handleGoToDashboardClick = () => {
    onChangeScreen(SCREENS.WORKSPACE);
  };

  const remoteConfig = getRemoteConfig();
  const isFeatureTemplatesEnabled = getBoolean(
    remoteConfig,
    'FEATURE_TEMPLATES'
  );

  useEffect(() => {
    logEvent(TrackingEvents.VIEW_TEMPLATES_PAGE);
  }, []);

  return (
    <Container>
      <S.Title>Retrospectives Settings</S.Title>
      <Button link size="sm" onClick={handleGoToDashboardClick}>
        ← Dashboard
      </Button>

      <Tabs activeIndex={0}>
        <Tab title="Templates" show={isFeatureTemplatesEnabled}>
          <TemplatesTab />
        </Tab>
      </Tabs>
    </Container>
  );
}

export default Settings;
